// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_TOPICS = "Sp\u00e4\u0165 na diskusn\u00e9 skupiny";
export const FORUM = "Diskusie";
export const FORUM_ADD_QUESTION_IN_COUNSELLING = "Polo\u017e ot\u00e1zku v poradni";
export const FORUM_ADD_REPLY = "Tu za\u010dni p\u00edsa\u0165 odpove\u010f...";
export const FORUM_MORE_DISCUSSIONS_FROM_topic = "Viac z %(topic)s";
export const FORUM_RECENT_POSTS = "Najnov\u0161ie ot\u00e1zky z poradne";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskusie";
export const REPORTED_COMMENTS = "Nahl\u00e1sen\u00e9 koment\u00e1re";
export const SEND_COMMENT_FORUM = "Odo\u0161li";
